import React, { useState, useEffect, useRef, memo } from 'react';
import { oneOf } from 'prop-types';

import classnames from 'classnames';
import Snackbar from '@andes/snackbar';

import FullSnackbar from '../full-shipping-snackbar/full-snackbar';
import useIntersectionObserver from '../../../hooks/use-intersection-observer';
import { setFullFreeShippingVisibility } from '../../../components/context/full-freeshipping';
import useFullFreeshipping from '../hooks/use-full-freeshipping';
import useTimeout from '../../../hooks/use-timeout';

const namespace = 'ui-search-fullpopup';

/**
 * Component FullShipping
 * @param {Object} props - Props del componente
 * @param {('up'|'down')} props.location - Ubicación del snackbar en la pantalla
 * @returns {JSX.Element} Componente de snackbar con información de envío para móvil
 */

const FullShipping = memo(({ location }) => {
  const [visible, setVisible] = useState(true);
  const refCruce = useRef();
  const headerRef = useRef();
  const [isOnScreen] = useIntersectionObserver(refCruce, { threshold: 0.2 }, 0.1, true);
  const { currentFullFreeshipping } = useFullFreeshipping();

  const handleVisibilityChange = (isVisible) => {
    setVisible(isVisible);
    setFullFreeShippingVisibility(isVisible);
  };

  const handleHeaderStyle = (shouldSetStyle) => {
    if (headerRef.current?.style) {
      headerRef.current.style.zIndex = shouldSetStyle ? '10' : '';
    }
  };

  useEffect(() => {
    headerRef.current = document.querySelector('.nav-header');
    handleVisibilityChange(true);
    handleHeaderStyle(true);

    return () => {
      handleHeaderStyle(false);
    };
  }, [currentFullFreeshipping]);

  useTimeout(() => {
    handleVisibilityChange(false);
    handleHeaderStyle(false);
  }, 5000);

  const containerClassName = classnames({
    'ui-search-fullpopup-up-float': isOnScreen,
    'ui-search-fullpopup-up-sticky': !isOnScreen,
  });

  const snackbarClassName = classnames(namespace, `${namespace}-${location}`, {
    [`${namespace}-${location}--animate-show`]: visible,
    [`${namespace}-${location}--animate-hide`]: !visible,
  });

  return (
    <>
      <div ref={refCruce} />
      <div className={containerClassName}>
        <Snackbar show={visible} className={snackbarClassName}>
          <FullSnackbar />
        </Snackbar>
      </div>
    </>
  );
});

FullShipping.displayName = 'FullShipping';

FullShipping.propTypes = {
  location: oneOf(['up', 'down']),
};

export default FullShipping;
